import { render, staticRenderFns } from "./DriverGroupDetailDialog.vue?vue&type=template&id=09c0dcc5&scoped=true"
import script from "./DriverGroupDetailDialog.vue?vue&type=script&lang=js"
export * from "./DriverGroupDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverGroupDetailDialog.vue?vue&type=style&index=0&id=09c0dcc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0dcc5",
  null
  
)

export default component.exports